/* Recherche predictive WarGrounds.
   S'appuie sur l'API native Shopify /search/suggest.json.
   Aucune dependance, un seul fichier, initialisation sur [data-wg-search]. */
(function () {
  var CFG = window.WG_SEARCH || {};
  var ENDPOINT = CFG.url || '/search/suggest.json';
  var CURRENCY = CFG.currency || 'EUR';
  var LIMIT = CFG.limit || 6;

  var money;
  try {
    money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: CURRENCY });
  } catch (e) {
    money = { format: function (n) { return n.toFixed(2) + ' €'; } };
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Les tags sont structures (gamme:xxx / taille:xx / lot:N) : on s'en sert en repli
     quand le titre du produit ne porte pas la taille. */
  function tagValue(tags, prefix) {
    var found = '';
    (tags || []).forEach(function (t) {
      if (String(t).indexOf(prefix) === 0) found = String(t).slice(prefix.length);
    });
    return found;
  }

  function sizeFrom(tags) {
    var s = tagValue(tags, 'taille:');
    if (!s) return '';
    if (s === '90x52') s = '52×90';
    return s + ' mm';
  }

  function lotFrom(tags) {
    var n = parseInt(tagValue(tags, 'lot:'), 10);
    if (!n || n < 1) return '';
    return n > 1 ? 'Lot de ' + n : 'À l’unité';
  }

  function thumb(p) {
    var src = p.image || (p.featured_image && p.featured_image.url) || '';
    if (!src) return '<span class="wg-sg__thumb is-empty"></span>';
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    return '<span class="wg-sg__thumb"><img src="' + esc(src + sep + 'width=120') + '" alt="" loading="lazy" width="60" height="60"></span>';
  }

  function render(panel, data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var collections = r.collections || [];
    var html = '';

    if (collections.length) {
      html += '<div class="wg-sg__group"><span class="wg-sg__head">Univers</span>';
      collections.slice(0, 3).forEach(function (c) {
        html += '<a class="wg-sg__row wg-sg__row--col" role="option" href="' + esc(c.url) + '">' +
          '<b>' + esc(String(c.title).split('—')[0].trim()) + '</b></a>';
      });
      html += '</div>';
    }

    if (products.length) {
      html += '<div class="wg-sg__group"><span class="wg-sg__head">Produits</span>';
      products.forEach(function (p) {
        /* Le titre porte deja gamme ET taille : « Socles Dry Lands — 28 mm ».
           On retire le prefixe generique et on garde les deux moities, la taille
           etant l'information qui distingue les resultats entre eux. */
        var raw = String(p.title).replace(/^socles\s+/i, '').trim();
        var bits = raw.split('—');
        var gamme = String(bits[0] || '').trim();
        var size = String(bits[1] || '').trim() || sizeFrom(p.tags);
        var lot = lotFrom(p.tags);
        var price = '';
        var n = parseFloat(p.price);
        if (!isNaN(n)) price = money.format(n);

        html += '<a class="wg-sg__row" role="option" href="' + esc(p.url) + '">' +
          thumb(p) +
          '<span class="wg-sg__txt">' +
            '<b>' + esc(gamme) +
              (size ? '<i class="wg-sg__size">' + esc(size) + '</i>' : '') +
            '</b>' +
            (lot ? '<small>' + esc(lot) + '</small>' : '') +
          '</span>' +
          (price ? '<span class="wg-sg__price">' + esc(price) + '</span>' : '') +
          '</a>';
      });
      html += '</div>';
    }

    if (!products.length && !collections.length) {
      html = '<div class="wg-sg__empty">Aucun résultat pour « ' + esc(q) + ' »</div>';
    } else {
      html += '<a class="wg-sg__all" href="/search?q=' + encodeURIComponent(q) + '">Voir tous les résultats →</a>';
    }

    panel.innerHTML = html;
  }

  function setup(form) {
    var input = form.querySelector('[data-wg-search-input]');
    var panel = form.querySelector('[data-wg-search-panel]');
    if (!input || !panel) return;

    var timer = null, controller = null, cursor = -1;

    function rows() { return panel.querySelectorAll('.wg-sg__row'); }

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      cursor = -1;
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function move(step) {
      var list = rows();
      if (!list.length) return;
      cursor += step;
      if (cursor < 0) cursor = list.length - 1;
      if (cursor >= list.length) cursor = 0;
      list.forEach(function (el, i) { el.classList.toggle('is-cursor', i === cursor); });
      list[cursor].scrollIntoView({ block: 'nearest' });
    }

    function query(q) {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = ENDPOINT + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection' +
        '&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) { return res.json(); })
        .then(function (data) { render(panel, data, q); open(); })
        .catch(function (err) { if (!err || err.name !== 'AbortError') close(); });
    }

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () { query(q); }, 220);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) open();
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter') {
        var list = rows();
        if (cursor >= 0 && list[cursor]) { e.preventDefault(); window.location.href = list[cursor].href; }
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-wg-search]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
